import Field from 'coreOld/components/Field';
import Tooltip from 'coreOld/components/Tooltip';
import { ENTER_KEYCODE } from 'coreOld/constants';
import { Icon } from 'coreOld/elements';
import { InputType, Size } from 'coreOld/enums';

interface IProps {
  handleChangeFilter?: (value: number | string) => void;
  onChange: (value: string) => void;
  filter: Record<string, any>;
  value: string;
  searchText: string;
  isSubmitted?: boolean;
  placeholder?: string;
}

const SearchFilterView = ({
  handleChangeFilter,
  onChange,
  filter,
  value,
  searchText,
  isSubmitted,
  placeholder,
}: IProps) => {
  const IconName = isSubmitted ? Icon.CLEAR_OUTLINED : Icon.SEARCH_ARROW;
  const TooltipText = isSubmitted ? 'Clear' : 'Search';

  return (
    <Field
      type={InputType.TEXTFIELD}
      name={filter.name}
      inputProps={{
        onChange: (e) => onChange(e.target.value),
        onKeyDown: (e) => {
          if (e?.keyCode === ENTER_KEYCODE) {
            handleChangeFilter(e.target.value);
          }
        },
        value: searchText,
        placeholder,
        size: Size.LG,
        icon: <Icon name={Icon.SEARCH} />,
        endIcon: (searchText || value) && (
          <Tooltip text={TooltipText}>
            <Icon name={IconName} onClick={() => handleChangeFilter(searchText)} />
          </Tooltip>
        ),
      }}
    />
  );
};

export default SearchFilterView;
